import { render } from "./WelcomeModal1.vue?vue&type=template&id=2e69e400&scoped=true&ts=true"
import script from "./WelcomeModal1.vue?vue&type=script&lang=ts&scoped=true"
export * from "./WelcomeModal1.vue?vue&type=script&lang=ts&scoped=true"

import "./WelcomeModal1.vue?vue&type=style&index=0&id=2e69e400&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e69e400"],['__file',"src/components/modals/start/WelcomeModal1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e69e400"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e69e400', __exports__)) {
    api.reload('2e69e400', __exports__)
  }
  
  module.hot.accept("./WelcomeModal1.vue?vue&type=template&id=2e69e400&scoped=true&ts=true", () => {
    api.rerender('2e69e400', render)
  })

}


export default __exports__